module.exports = __webpack_public_path__ + "media/pages/book/components/images/platform-icons/android-826de5e8d42599d8785a9c8fa08052cb.svg";